import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import styles from './Contact.module.scss'

const Contact: React.FC = () => {
  useHubSpotGenerate('na1', '9395227', '7627e517-d385-49b8-9b6a-4a86df93c5a3', '#sp_hbspt')

  return (
    <section className={styles.contact} id="contact">
      <span className={styles.title}>お問い合わせ</span>
      <div className="lp_hubSpot" id="sp_hbspt"></div>
    </section>
  )
}

export default Contact
